import { Stack, Tooltip, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { MaterialSymbol } from '@/components/MaterialSymbol';

/**
 * An icon and a short label on one line — ported from Web's `ui/IconedLabel`,
 * which the Project Portfolio's preview panel lays its customer and project
 * manager out with (3 Nov, Mette: the task panel's details follow it). Web's
 * `secondary` icon colour is fog-80 and its default size 24; the label is the
 * design system's `label` variant, as in Web.
 */
export type IconedLabelProps = {
  icon: string;
  children: ReactNode;
  /** Shown on hover and focus — what the value is, when the icon alone does not say. */
  tooltip?: ReactNode;
  automationId?: string;
  /** Web's `typographyProps={{ uppercase: true }}` — the recommendation card's NEXT STEP. */
  uppercase?: boolean;
};

export const IconedLabel = ({
  icon,
  children,
  tooltip,
  automationId,
  uppercase,
}: IconedLabelProps) => {
  const content = (
    <Stack
      direction="row"
      data-automation-id={automationId}
      tabIndex={tooltip ? 0 : undefined}
      sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}
    >
      <MaterialSymbol name={icon} size={24} color="var(--color-fog-80)" />
      <Typography component="p" variant="label" uppercase={uppercase} sx={{ m: 0 }}>
        {children}
      </Typography>
    </Stack>
  );
  return tooltip ? <Tooltip title={tooltip}>{content}</Tooltip> : content;
};
